module.exports = new __parcel__URL__("mRESVIA_both.f075b2cc.jpg").toString();